import { useTranslation } from 'react-i18next'

import { StepperStep } from './stepper-step'

export const NewCustomerCompanyProcessStepper = ({ currentStep, handleGoToStep }: { currentStep: number; handleGoToStep: (stepToGo: number) => void }) => {
  const { t } = useTranslation(['customer-companies-management'])

  return (
    <div className="stepper-steps-container">
      <StepperStep
        isFirstStep
        isCurrent={currentStep === 1}
        isCompleted={currentStep >= 2}
        isLastActive={currentStep >= 2}
        handleGoToStep={handleGoToStep}
        stepName={t('stepper.stepNames.stepOne')}
        stepDescription={t('stepper.stepDescriptions.stepOne')}
      />
      <StepperStep
        isLastStep
        isCurrent={currentStep === 2}
        handleGoToStep={handleGoToStep}
        isFirstActive={currentStep === 2}
        stepName={t('stepper.stepNames.stepTwo')}
        stepDescription={t('stepper.stepDescriptions.stepTwo')}
      />
    </div>
  )
}
